import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Receipt } from "@phosphor-icons/react";
import { api } from "@/lib/api";

/**
 * VendorSpendPill — drop this on any page to show vendor-bill spend for the
 * scope. Pass no props for the whole tenant, or address/unit to filter.
 *   <VendorSpendPill />
 *   <VendorSpendPill address="5346 Chew Ave" />
 *   <VendorSpendPill address="5346 Chew Ave" unit="20B" />
 */
export default function VendorSpendPill({ address, unit, days, compact = false }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    const params = {};
    if (address) params.address = address;
    if (unit) params.unit = unit;
    if (days) params.days = days;
    api.get("/vendor-bills/spend", { params })
      .then(r => setD(r.data)).catch(() => setD({ count: 0, total_cents: 0, unpaid_cents: 0 }));
  }, [address, unit, days]);
  if (!d || d.count === 0) return null;
  const $ = (c) => `$${(c / 100).toFixed(2)}`;
  const hasUnpaid = d.unpaid_cents > 0;
  if (compact) {
    return (
      <Link to="/admin/vendor-bills" data-testid="vendor-spend-pill"
        className={`inline-flex items-center gap-1 px-2 py-1 text-[10px] font-black uppercase tracking-widest ${
          hasUnpaid ? "bg-red-600 text-white" : "bg-emerald-600 text-white"
        }`}>
        <Receipt weight="fill" size={11}/>
        {d.count} bill{d.count === 1 ? "" : "s"} · {$(d.total_cents)}
        {hasUnpaid && <span className="ml-1 bg-white/25 px-1">{$(d.unpaid_cents)} UNPAID</span>}
      </Link>
    );
  }
  return (
    <Link to="/admin/vendor-bills" data-testid="vendor-spend-pill"
      className={`block p-3 border-2 hover:shadow-[3px_3px_0_#0f172a] transition-shadow ${
        hasUnpaid ? "border-red-600 bg-red-50" : "border-emerald-600 bg-emerald-50"
      }`}>
      <div className="flex items-center gap-2">
        <Receipt weight="fill" size={16} className={hasUnpaid ? "text-red-600" : "text-emerald-600"}/>
        <div className="text-[10px] font-black uppercase tracking-widest text-slate-600">
          Vendor Spend {address ? "· scope" : ""} {days ? `· last ${days}d` : ""}
        </div>
      </div>
      <div className="mt-1 flex items-baseline gap-3">
        <div className="font-display font-black text-2xl">{$(d.total_cents)}</div>
        <div className="text-[10px] font-black uppercase tracking-widest text-slate-500">{d.count} bill{d.count === 1 ? "" : "s"}</div>
      </div>
      {hasUnpaid && (
        <div className="mt-1 text-[11px] font-black uppercase tracking-widest text-red-700">
          {$(d.unpaid_cents)} unpaid · tap to review
        </div>
      )}
    </Link>
  );
}
